import { createElement } from './create-element';
const classes = {
    base: 'gh-toast',
    hidden: 'gh-toast--hidden',
    dismissed: 'gh-toast--dismissed',
    containerDismissed: 'gh-toast__container--dismissed',
    close: 'gh-toast__close',
    content: 'gh-toast__content',
};
class Toasts {
    container;
    queue = new Set();
    constructor() {
        this.container = createElement({
            classNames: ['gh-toasts'],
        });
        document.body.appendChild(this.container);
    }
    onToastRemoved = (t) => {
        this.queue.delete(t);
        if (this.queue.size) {
            this.queue.values().next()?.value?.hasFocus();
        }
    };
    make(content, type = 'info', { heading = null, dismissible = true, timeoutSeconds = 10, } = {}) {
        const t = new Toast(this.container, this.onToastRemoved, content, type || 'info', heading, dismissible, timeoutSeconds);
        if (!this.queue.size) {
            t.hasFocus();
        }
        this.queue.add(t);
        return t.show();
    }
}
class Toast {
    onRemoved;
    content;
    type;
    heading;
    dismissible;
    timeoutSeconds;
    _element = null;
    contentElement;
    timer = 0;
    closeButton = null;
    constructor(container, onRemoved, content, type = 'info', heading = null, dismissible = true, timeoutSeconds = 10) {
        this.onRemoved = onRemoved;
        this.content = content;
        this.type = type;
        this.heading = heading;
        this.dismissible = dismissible;
        this.timeoutSeconds = timeoutSeconds;
        this.contentElement = this.createContent();
        container.appendChild(this.element);
    }
    get element() {
        if (!this._element) {
            this._element = createElement({
                type: 'ASIDE',
                classNames: [
                    classes.base,
                    classes.hidden,
                    `gh-toast--${this.type}`,
                ],
                attributes: {
                    'aria-hidden': 'true',
                },
            });
        }
        return this._element;
    }
    show() {
        this.element.classList.remove(classes.hidden);
        this.element.setAttribute('aria-hidden', 'false');
        if (this.dismissible && this.closeButton) {
            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }
        return this;
    }
    hasFocus() {
        if (this.timeoutSeconds) {
            this.timer = window.setTimeout(() => {
                void this.destroy();
            }, this.timeoutSeconds * 1000);
        }
    }
    hide() {
        this.contentElement.addEventListener('transitionend', () => {
            this.element.classList.add(classes.hidden);
        });
        this.contentElement.classList.add(classes.containerDismissed);
        this.element.setAttribute('aria-hidden', 'true');
        return this;
    }
    destroy = async () => {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        return new Promise((res) => {
            this.element.addEventListener('transitionend', () => {
                this.destroyElement();
                res();
            });
            this.hide();
        });
    };
    destroyElement() {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.closeButton = null;
        this.element.remove();
        this._element = null; // tslint-ignore
        this.onRemoved(this);
    }
    createContent() {
        const contentElement = createElement({
            classNames: ['gh-toast__container'],
            parent: this.element,
        });
        if (this.dismissible) {
            this.closeButton = createElement({
                type: 'BUTTON',
                classNames: [classes.close],
                parent: contentElement,
                content: '×',
                attributes: {
                    type: 'button',
                },
            });
            this.closeButton.addEventListener('click', () => void this.destroy());
        }
        const container = createElement({
            classNames: [classes.content],
            parent: contentElement,
        });
        if (this.heading) {
            createElement({
                type: 'H1',
                content: this.heading,
                parent: container,
            });
        }
        createElement({
            type: 'P',
            classNames: [classes.content],
            parent: container,
            content: this.content,
        });
        return contentElement;
    }
}
export const toasts = new Toasts();
//# sourceMappingURL=toast.js.map